









import Vue from "vue";
import OrderableProductBase from '@/components/v2/orderable-product/OrderableProductBase.vue';
import ProductCard from '@/components/v2/product-item/ProductCard.vue';

export default Vue.extend({
    name: "OrderableProductCard",
    components: {
        OrderableProductBase,
        "product-card": ProductCard
    },
    props: {
        productKey: {
            type: String,
            required: true
        }
    }
});
